import 'slick-carousel/slick/slick';

(function ($, viewport) {
    $(document).ready(() => {

        // generic sliders
        $('.slick').each((index, el) => {
            let slickId = el.getAttribute('id');
            if (!el.hasAttribute('id')) {
                el.setAttribute('id', slickId = 'slick_' + (new Date().getTime()));
            }
            const slidesToShow = el.hasAttribute('data-slides-to-show') ? parseFloat(el.getAttribute('data-slides-to-show')) : 3.5;

            $(el).slick({
                infinite: false,
                dots: false,
                slidesToShow: slidesToShow,
                slidesToScroll: 1,
                prevArrow: `<button type="button" class="slick-prev"><span class="d-none d-lg-inline-block">${shoez_translations.prev}</span><span class="d-inline-block d-lg-none">&lt;</span></button>`,
                nextArrow: `<button type="button" class="slick-next"><span class="d-none d-lg-inline-block">${shoez_translations.next}</span><span class="d-inline-block d-lg-none">&gt;</span></button>`,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3,
                        },
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 2,
                        },
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                        },
                    },
                ]
            });
        });

        // homepage slider
        let sliderInitialized = false;
        const shuffledImagesSliderForClass = '.shuffled-images-slider-for';
        const shuffledImagesSliderNavClass = '.shuffled-images-slider-nav';
        const shuffledImagesSliderFor = $(shuffledImagesSliderForClass);
        const shuffledImagesSliderNav = $(shuffledImagesSliderNavClass);
        const featuredProductsCategoryClass = '.featured-products-category .products';
        const featuredProductsCategory = $(featuredProductsCategoryClass);
        const updateSlider = () => {
            if (viewport.is('<lg')) {
                sliderInitialized = true;
                shuffledImagesSliderFor.slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    fade: true,
                    asNavFor: shuffledImagesSliderNavClass,
                });
                shuffledImagesSliderNav.slick({
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    asNavFor: shuffledImagesSliderForClass,
                    dots: false,
                    centerMode: true,
                    focusOnSelect: true,
                    arrows: false,
                });
                featuredProductsCategory.slick({
                    infinite: false,
                    dots: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    prevArrow: `<button type="button" class="slick-prev">&lt;</button>`,
                    nextArrow: `<button type="button" class="slick-next">&gt;</button>`,
                });
            } else {
                if (sliderInitialized) {
                    shuffledImagesSliderFor.slick('unslick');
                    shuffledImagesSliderNav.slick('unslick');
                    featuredProductsCategory.slick('unslick');
                }
                sliderInitialized = false;
            }
        }
        updateSlider();
        $(window).resize(viewport.changed(updateSlider));
    });
} (require('jquery'), require('responsive').default));
